<template>
    <div id="selector">
        <ToggleWholesalable @toggle-changed="toggleWholesaleForm"/>
        <div v-show='toggle'>
            <br/>
            <div class="borderline">
                <br/>
                <div class="address-wrapper">
                    <input
                        v-model="wholesale_price"
                        class="fieldZipCode inp"
                        :class="{ errorBg: $v.wholesale_price.$error }"
                        type="text"
                        name="wholesalePrice"
                        maxlength="5"
                        @blur="$v.wholesale_price.$touch()"
                        @keyup="preventFirstZero($event)"
                        @change="sendData"
                        :placeholder="$t('wholesale_price')"
                        data-qa="wholesalePriceInput"
                    />	                
                    <template v-if="$v.wholesale_price.$error">
                        <p v-if="!$v.wholesale_price.required" class="errorMessage">{{ $t('wholesale_price_req') }}</p>
                    </template>
                    <div>
                        <input
                                v-model="sugg_selling_price"
                                class="field fieldZipCode inp"
                                :class="{ errorBg: $v.sugg_selling_price.$error }"
                                type="text"
                                maxlength=5  
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                name="pickUpCode"
                                @keyup="preventFirstZero($event)"
                                @change="sendData"
                                @blur="$v.sugg_selling_price.$touch()"
                                :placeholder="$t('sugg_selling_price')"
                                data-qa="suggSellingPriceInput"
                        />
                    </div>
                    <template v-if="$v.sugg_selling_price.$error">
                        <p v-if="!$v.sugg_selling_price.required" class="errorMessage">{{ $t('sugg_selling_price_req') }}</p>
                    </template>
                    <div>
                        <input
                                v-model="moq"
                                class="fieldPrice2 inp"
                                :class="{ errorBg: $v.moq.$error }"
                                type="text"
                                name="moq"
                                maxlength="25"
                                @blur="$v.moq.$touch()"
                                @keyup="preventFirstZero($event)"
                                @change="sendData"
                                :placeholder="$t('moq')"
                                data-qa="moqInput"
                        />
                    </div>
                    <template v-if="$v.moq.$error">
                        <p v-if="!$v.moq.required" class="errorMessage">{{ $t('moq_req') }}</p>
                    </template> 
					<div>
						<input
							v-model="info_pack_sizes"
							class="field inp"
							:class="{ errorBg: $v.info_pack_sizes.$error }"
							type="text"
							name="info_pack_sizes"
							maxlength="25"
							@blur="$v.info_pack_sizes.$touch()"
							@keyup="preventFirstZero($event)"
							@change="sendData"
							:placeholder="$t('infoPackSizes')"
							data-qa="infoPackSizesInput"
						/>						
					</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import ToggleWholesalable from '../common/ToggleWholesalable'

export default {
    name: "selector",
    components: {
        ToggleWholesalable
    },
    data() {
        return {
            toggle: true,
            wholesale_price: '',
            sugg_selling_price: '',
            moq: '',
            info_pack_sizes: '',
            widget: null,
            isDimensionValid: false
        }
    },
    validations: {
        wholesale_price: { required },
        sugg_selling_price: { required },
        moq: { required },
        info_pack_sizes: {}
    },
    methods: {
        toggleWholesaleForm(toggle) {
            this.toggle = toggle
            this.sendData()
        },
        sendData() {
            if (this.toggle && !this.$v.$invalid) {
                this.$emit('wholesale-details', {
                    wholesale_price: this.wholesale_price,
                    sugg_selling_price: this.sugg_selling_price,
                    moq: this.moq,
                    info_pack_sizes: this.info_pack_sizes,
                    wholesalable: this.toggle
                })
            } else {
                this.$emit('wholesale-details', {
                    wholesalable: this.toggle
                })
            }
        },
        preventFirstZero(event) {
            event.target.value = parseInt(event.target.value) === 0  ? null : event.target.value
        }
    },
    mounted() {
        this.sendData()
    }    
}
</script>

<style lang="scss" scoped>

.login-btn{
  color: var(--primary) !important;
  border: 1px solid var(--primary);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.login-btn:hover{
  background: var(--primary);
  color: var(--bright) !important;
}

.closedForm {
    background-color: var(--primary);
}
.openForm{
    background-color: var(--bg);
}
.shippable {
   display: none;
}
.nonShippable{
    display: block;
}
.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
}
.field {
  width: 80%;
}
.fieldZipCode {
  width: 50%;
  margin: 0px 25px 0px 0px;

}
.errorBg {
  background-color: var(--primarySuperLight) !important;
  // border-color: none;
  border-bottom: 0.2px solid var(--primary);
}
.borderline {
    border: solid 1px var(--bg);
    padding: 10px;
}
.iconBigBtn {
    margin: 40px auto 10px auto;
    display: flex;
    border: none;
    outline: none;
    border-radius: 5px;
    align-items: center;
    height: 100px;
    width: 300px;
    padding: 15px;
}

.iconBtn {
    font-size: 3em;
    padding: 5px;
    margin-right: 10px;
    color: var(--bright);
}
.textBtn {
    color: var(--bright);
    text-align: left;
    padding: 5px;
}
.fieldPrice {
  width: 30%;
} 

section label {
  color: var(--primary);
  font-weight: 600;
}

.price-wrapper {
  display: flex;
}

.price-wrapper span {
  font-weight: 600;
  font-size: 1.3em;
  margin-left: 5px;
  color: var(--bg);
}
.stockInput span {
  font-weight: 600;
  font-size: 1.0em;
  margin-left: 5px;
  color: var(--bg);
}

.questionMark {
  color: var(--bright) !important;
  border-radius: 50% !important;
  border: none;
  background-color: var(--bg) !important;
  padding: 2px 6px !important;
  margin-left: 5px !important; 
  margin-right: 3px !important;
}

.questionMark:hover {
  background-color: var(--primary) !important;
}
.inp {
    border:none;
    border-bottom: 0.2px solid var(--bg);
    padding: 5px 10px;
    outline: none;
    margin-bottom: 1.2em;
    background-color: var(--grey-superlight);
 }
 .inp:hover {
   border-color: var(--primary);
 }

 @media screen and (min-width: 500px){
 .address-wrapper {
	text-align: left;
    margin-left: 20px;
 }
 }
@media screen and (max-width: 500px){
.iconBigBtn {
    margin: 10px auto 4px auto;
    display: block;
    height: auto;
    width: 100%;
    padding: 5px;
}
.iconBtn {
    font-size: 2.5em;
    margin-right: 0px;
    margin: 0;
    padding: 0;
}
.textBtn {
    text-align: center;
    font-size: 0.8em;
}
.price-wrapper {
  display: block;
}
.price-wrapper span {
  font-size: 0.9em;
}
.field {
  width: 100%;
}
section label {
line-height: 1.2em;
}
}
</style>

<style>
/* global styles */
.pac-container {
    z-index: 1042 !important;
}
</style>